const imgTeamGoodsPackageHoverWorkCards = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img3 = "./assets/figma/2edd67fc-a64e-4dd7-8cb4-21b2dabe8697.png";
const img2026923382 = "./assets/figma/28434674-e6be-4dd7-bed7-6a17cba426a6.png";
const img2026923373 = "./assets/figma/0055b262-7091-4522-ae89-23e7c6b7377a.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/10c9e57a-3d9e-46bd-aa90-dd15d7868e23.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamGoodsPackageHoverWorkCards() {
  return (
    <div className="s0 s1" data-node-id="886:1343" data-name="TEAM_GOODS/PACKAGE/HOVER_WORK_CARDS">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s440 s441 s9 s10 s442" src={imgTeamGoodsPackageHoverWorkCards} />
        </div>
      </div>
      <div className="s2 s12 s13 s443 s15" data-node-id="886:1346" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s238 s22" data-node-id="886:1347">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="886:1348">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:1349">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="886:1350">
            DOMINO TILES · 30 × 48 × 5 MM · 15
            <br aria-hidden />
            GAME BOARD · 550 × 550 MM · 1<br aria-hidden />
            CARDS · 63 × 88 MM · 20
            <br aria-hidden />
            INSTRUCTION PANEL
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="886:1351">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="886:1352">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:1353">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="886:1354">
            신지수
            <br aria-hidden />
            윤현서
            <br aria-hidden />
            지윤주
            <br aria-hidden />
            홍민지
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s239 s54" data-node-id="886:1355">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s240 s57" data-node-id="886:1356">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="886:1357">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="886:1358">
          <p className="s39 s40">{`패키지/굿즈팀은 원하는 결과에 도달하기 위해 AI를 선택하고 조합하는 과정을 도미노 보드게임 패키지로 `}</p>
          <p className="s39 s40">{`시각화했다. 2~4명의 플레이어는 게임 시작 시 결과 구슬 카드를 뽑아 목표를 정하고 AI 도미노를 나누어 가진다. `}</p>
          <p className="s39 s40">{`이후 카드에 제시된 조건에 맞는 도미노를 골라 순서대로 연결하며 각자의 AI 파이프라인을 구성한다. `}</p>
          <p className="s39 s40">{`조건을 가장 먼저 충족해 도미노 라인을 완성한 플레이어가 승리하고, 완성된 도미노를 직접 쓰러뜨리며 AI의 `}</p>
          <p className="s39">선택과 조합에서 결과 도출까지 이어지는 과정을 놀이로 경험하도록 제작했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s326 s27 s29 s61 s241 s54" data-node-id="886:1359">
        GOODS/PACKAGE
      </p>
      <div className="s2 s327 s328 s240 s329" data-node-id="886:1360" data-name="패키지팀 3">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img3} />
      </div>
      <div className="s2 s16 s17 s24 s332 s26 s20 s242 s334" data-node-id="886:1361">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="886:1362">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="886:1363" data-name="TEAM_GOODS/PACKAGE_WORK">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="886:1364">
            <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:1366" data-name="이미지 2026. 9. 2. 오후 3.38 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
              </div>
            </div>
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:1368" />
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="886:1370">
            <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:1371" data-name="패키지팀 4">
              <img alt="" className="s2 s3 s9 s105 s4 s70 s1" src={img3} />
            </div>
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:1373" />
          </div>
          <a className="s141 s335 s336 s337 s338 s0 s28" data-node-id="886:1375">
            <div className="s244 s192 s245 s444 s445 s0 s70 s198 s248" data-node-id="886:1376" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s349 s350 s9 s10 s351" src={img2026923373} />
              </div>
            </div>
            <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:1377" style={{ backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%)" }} />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:1378" />
            <p className="s23 s192 s31 s249 s458 s459 s27 s0 s198 s251 s85 s138 s253 s54" data-node-id="886:1379">
              CARDS
            </p>
          </a>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="886:1380">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="886:1381" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="886:1382">
          <div className="s111 s0 s28 s112" data-node-id="886:1383" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="886:1388">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="886:1389">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="886:1390">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1391">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1392">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="886:1393">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1394">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1395">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="886:1396">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1397">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1398">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}